import { CURRENT_BRAND } from "@/brand/config";
import {
  COLOR_SCHEMES,
  COLOR_SCHEME_CLASS,
  type ColorSchemeVariant,
  type ModeVariant,
} from "@/constants";
import { scopedStorage, STORAGE_KEYS } from "@/lib/storage";

export function applyTheme(opts?: {
  colorScheme?: ColorSchemeVariant;
  mode?: ModeVariant;
}): void {
  const root = document.documentElement;

  Array.from(root.classList).forEach((c) => {
    if (
      c.startsWith("theme-") ||
      c.startsWith("color-scheme-") ||
      c === "dark"
    )
      root.classList.remove(c);
  });

  if (CURRENT_BRAND.themeVariant) {
    root.classList.add(CURRENT_BRAND.themeVariant);
  }

  const scheme = opts?.colorScheme || readColorScheme();
  const schemeClass = COLOR_SCHEME_CLASS[scheme];
  if (schemeClass) root.classList.add(schemeClass);

  const mode = opts?.mode || readMode();
  const dark =
    mode === "dark" ||
    (mode === "system" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches);
  if (dark) root.classList.add("dark");
}

export function readColorScheme(): ColorSchemeVariant {
  const raw = scopedStorage.get(STORAGE_KEYS.colorScheme);
  if (raw && Object.values(COLOR_SCHEMES).includes(raw as ColorSchemeVariant)) {
    return raw as ColorSchemeVariant;
  }
  return COLOR_SCHEMES.DEFAULT;
}

export function writeColorScheme(scheme: ColorSchemeVariant): void {
  scopedStorage.set(STORAGE_KEYS.colorScheme, scheme);
  applyTheme({ colorScheme: scheme });
}

export function readMode(): ModeVariant {
  const raw = scopedStorage.get(STORAGE_KEYS.themeMode);
  if (raw === "dark" || raw === "light" || raw === "system") return raw;
  return "light";
}

export function writeMode(mode: ModeVariant): void {
  scopedStorage.set(STORAGE_KEYS.themeMode, mode);
  applyTheme({ mode });
}
